export default __webpack_public_path__ + "static/media/background-earth.light.89e49e6d.png";